var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.examType == ""
        ? _c("div", { staticClass: "label" }, [_vm._v("选择等级赋分类型")])
        : _vm.examType == "1"
        ? _c("div", { staticClass: "label" }, [_vm._v("3+1+2考试模式")])
        : _vm.examType == "4"
        ? _c("div", { staticClass: "label" }, [_vm._v("8档")])
        : _vm.examType == "3"
        ? _c("div", { staticClass: "label" }, [_vm._v("11档")])
        : ["2", "5", "6"].indexOf(_vm.examType + "") > -1
        ? _c("div", { staticClass: "label" }, [_vm._v("21档")])
        : _vm.examType == "7"
        ? _c("div", { staticClass: "label" }, [_vm._v("3+大综合")])
        : _vm._e(),
      _c(
        "el-steps",
        { attrs: { active: _vm.active, "align-center": "" } },
        _vm._l(_vm.stepList, function (item, index) {
          return _c("el-step", {
            key: index,
            class: _vm.stepClass(index),
            attrs: { title: item.title, icon: _vm.stepIcon(index) },
            nativeOn: {
              click: function ($event) {
                return _vm.jumpPage(item, index)
              },
            },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }